
// tslint:disable-next-line: no-namespace
export namespace Status {
  //////////////////////// ENUM ////////////////////////

  export enum UserEnum {
    AllStatus = -1,
    Invite = 0,
    Inactive = 1,
    Active = 2,
  }

  export enum RoleTradeEnum {
    Inactive = 0,
    Active = 1,
  }

  export enum CategoryEnum {
    Inactive = 0,
    Active = 1
  }

  export enum FlowStatus {
    New = 0,
    InProgress = 1,
    Inactive = 2,
    Active = 3,
  }

  export enum ComplianceFlowEnum {
    New = 0,
    InProgress = 1,
    Inactive = 2,
    ForValidation = 3,
    Validated = 4,
    Rejected = 5,
    Live = 6,
  }

  export enum FlowEnum {
    ForValidation = 3,
    Validated = 4,
    Rejected = 5,
    Live = 6,
  }

  export enum EirEnum {
    New = 0,
    InProgress = 1,
    Cancelled = 2,
    Completed = 3,
  }

  /**
   * Alert Validate status.
   * 0. ForValidation
   * 1. Approved
   * 2. Rejected
   */
  export enum AlertsValidateEnum {
    ForValidation = 0,
    Validated = 1,
    Rejected = 2,
  }

  export enum JourneyEnum {
    New = 0,
    In_Transit = 1,
    Rejected = 2,
    Completed = 3
  }
  export enum JourneyEnum2 {
    New = 0,
    In_Progress = 1,
    Cancelled = 2,
    Completed = 3
  }

  //////////////////////// CONST ////////////////////////

  export const VIEW_MODE = [FlowEnum.ForValidation, FlowEnum.Validated, FlowEnum.Live];

  export const IntermodalStatus = {
    AllStatus: -1,
    New: 0,
    InProgress: 1,
    Cancelled: 2,
    Completed: 3,
  };

  export const Company = {
    Invite: 0,
    Inactive: 1,
    Active: 2,
  };

  export const Request = {
    AllStatus: -1,
    RequestSent: 0,
    InProgress: 1,
    RequestDenied: 2,
    QuoteSent: 3,
    QuoteDenied: 4,
    QuoteAccepted: 5,
  };

  export const RequestCredential = {
    Public: false,
    Private: true,
  };

  export const RequestUserType = {
    Requester: 0,
    Provider: 1,
    Unknown: 2,
  };

  export const Bol = {
    New: 0,
    InProgress: 1,
    Cancelled: 2,
    Completed: 3,
  };

  export const EntryStatus = {
    New: 0,
    Entry_Approved: 1,
    Entry_Rejected: 2,
    Exit_Approved: 3,
    Exit_Rejected: 4,
    Cancelled: 5,
  };

  export const EntryRecord = {
    Other: 0,
    Loading: 1,
    Unloading: 2,
    SiteActivities: 3,
  };

  export const EntryRecordInspect = {
    Approved: 1,
    Rejected: 0,
  };

  export const RequestStatusArr = [
    {
      value: Request.RequestSent,
      label: 'Request Sent',
    },
    {
      value: Request.InProgress,
      label: 'In Progress',
    },
    {
      value: Request.RequestDenied,
      label: 'Request Denied',
    },
    {
      value: Request.QuoteSent,
      label: 'Quote Sent',
    },
    {
      value: Request.QuoteDenied,
      label: 'Quote Denied',
    },
    {
      value: Request.QuoteAccepted,
      label: 'Quote Accepted',
    },
  ];

  export const FLOW = [
    {
      value: FlowStatus.New,
      label: 'New',
    },
    {
      value: FlowStatus.InProgress,
      label: 'In Progress',
    },
    {
      value: FlowStatus.Inactive,
      label: 'Inactive',
    },
    {
      value: FlowStatus.Active,
      label: 'Active',
    },
  ];

  export const Eir = [
    {
      value: EirEnum.New,
      label: 'New',
    },
    {
      value: EirEnum.InProgress,
      label: 'In Progress',
    },
    {
      value: EirEnum.Cancelled,
      label: 'Cancelled',
    },
    {
      value: EirEnum.Completed,
      label: 'Completed',
    },
  ];

  export const EntryRecordStatusArr = [
    {
      value: EntryRecordInspect.Approved,
      label: 'Approved',
    },
    {
      value: EntryRecordInspect.Rejected,
      label: 'Rejected',
    },
  ];

  export const EntryStatusArr = [
    {
      value: EntryStatus.New,
      label: 'New',
    },
    {
      value: EntryStatus.Entry_Approved,
      label: 'Entry - Approved',
    },
    {
      value: EntryStatus.Entry_Rejected,
      label: 'Entry - Rejected',
    },
    {
      value: EntryStatus.Exit_Approved,
      label: 'Exit - Approved',
    },
    {
      value: EntryStatus.Exit_Rejected,
      label: 'Exit - Rejected',
    },
    {
      value: EntryStatus.Cancelled,
      label: 'Cancelled',
    },
  ];

  export const credentialStatusArr = [
    {
      value: RequestCredential.Private,
      label: 'Private',
    },
    {
      value: RequestCredential.Public,
      label: 'Public',
    }
  ];

  export const ComplianceFlowStatuses = [
    {
      value: ComplianceFlowEnum.New,
      label: 'New',
    },
    {
      value: ComplianceFlowEnum.InProgress,
      label: 'In Progress',
    },
    {
      value: ComplianceFlowEnum.Inactive,
      label: 'Inactive',
    },
    {
      value: ComplianceFlowEnum.ForValidation,
      label: 'For Validation',
    },
    {
      value: ComplianceFlowEnum.Validated,
      label: 'Validated',
    },
    {
      value: ComplianceFlowEnum.Rejected,
      label: 'Rejected',
    },
    {
      value: ComplianceFlowEnum.Live,
      label: 'Live',
    },
  ];

  export const IntermodalStatusArr = [
    {
      value: IntermodalStatus.New,
      label: 'New',
    },
    {
      value: IntermodalStatus.InProgress,
      label: 'In Progress',
    },
    {
      value: IntermodalStatus.Cancelled,
      label: 'Cancelled',
    },
    {
      value: IntermodalStatus.Completed,
      label: 'Completed',
    }
  ];

  export const User = [
    {
      value: UserEnum.Invite,
      label: 'Invite',
    },
    {
      value: UserEnum.Inactive,
      label: 'Inactive',
    },
    {
      value: UserEnum.Active,
      label: 'Active',
    },
  ];

  export const RoleTrade = [
    {
      value: RoleTradeEnum.Active,
      label: 'Active',
    },
    {
      value: RoleTradeEnum.Inactive,
      label: 'Inactive',
    },
  ];

  export const Category = [
    {
      value: CategoryEnum.Active,
      label: 'Active',
    },
    {
      value: CategoryEnum.Inactive,
      label: 'Inactive',
    },
  ];

  /**
   *  Alert Validate statuses
   */
  export const AlertsValidateStatuses = [
    {
      value: AlertsValidateEnum.ForValidation,
      label: 'For Validation',
    },
    {
      value: AlertsValidateEnum.Validated,
      label: 'Validated',
    },
    {
      value: AlertsValidateEnum.Rejected,
      label: 'Rejected',
    },
  ];

  export const JourneyStatuses = [
    {
      value: JourneyEnum.New,
      label: 'New',
    },
    {
      value: JourneyEnum.In_Transit,
      label: 'In Transit',
    },
    {
      value: JourneyEnum.Rejected,
      label: 'Rejected',
    },
    {
      value: JourneyEnum.Completed,
      label: 'Completed',
    },
  ];

  export const JourneySearchStatuses = [
    {
      value: JourneyEnum2.New,
      label: 'New',
    },
    {
      value: JourneyEnum2.In_Progress,
      label: 'In Progress',
    },
    {
      value: JourneyEnum2.Cancelled,
      label: 'Cancelled',
    },
    {
      value: JourneyEnum2.Completed,
      label: 'Completed',
    },
  ];

  export const JourneyStatusesCustom = [
    {
      value: JourneyEnum.New,
      label: 'New',
    },
    {
      value: JourneyEnum.In_Transit,
      label: 'In Transit',
    },
    {
      value: `[${JourneyEnum.New},${JourneyEnum.In_Transit}]`,
      label: 'Open',
    },
    {
      value: JourneyEnum.Rejected,
      label: 'Rejected',
    },
    {
      value: JourneyEnum.Completed,
      label: 'Completed',
    },
    {
      value: `[${JourneyEnum.Completed},${JourneyEnum.Rejected}]`,
      label: 'Closed',
    },
  ];
}
